/**
 * @generated SignedSource<<64d987680eaf97ad3df7137360486810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraFormattingArea = "CELL" | "ROW" | "%future added value";
export type JiraFormattingMultipleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "HAS_ANY_OF" | "%future added value";
export type JiraFormattingNoValueOperator = "IS_EMPTY" | "IS_NOT_EMPTY" | "%future added value";
export type JiraFormattingSingleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "DOES_NOT_EQUAL" | "EQUALS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUALS" | "IS" | "IS_AFTER" | "IS_BEFORE" | "IS_NOT" | "IS_ON_OR_AFTER" | "IS_ON_OR_BEFORE" | "LESS_THAN" | "LESS_THAN_OR_EQUALS" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type FormatRules$data = {
  readonly conditionalFormattingRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly expression: {
          readonly __typename: "JiraFormattingMultipleValueOperand";
          readonly fieldId: string;
          readonly multipleValueOperator: JiraFormattingMultipleValueOperator;
          readonly values: ReadonlyArray<string>;
        } | {
          readonly __typename: "JiraFormattingNoValueOperand";
          readonly fieldId: string;
          readonly noValueOperator: JiraFormattingNoValueOperator;
        } | {
          readonly __typename: "JiraFormattingSingleValueOperand";
          readonly fieldId: string;
          readonly singleValueOperator: JiraFormattingSingleValueOperator;
          readonly value: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
        readonly formattingArea: JiraFormattingArea;
        readonly formattingColor: {
          readonly colorKey: string | null | undefined;
        };
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "FormatRules";
};
export type FormatRules$key = {
  readonly " $data"?: FormatRules$data;
  readonly " $fragmentSpreads": FragmentRefs<"FormatRules">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "fieldId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "FormatRules",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "JiraFormattingRuleConnection",
      "kind": "LinkedField",
      "name": "conditionalFormattingRules",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraFormattingRuleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraFormattingRule",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "formattingColor",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "formattingArea"
                },
                {
                  "kind": "LinkedField",
                  "name": "expression",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "singleValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "value"
                        }
                      ],
                      "type": "JiraFormattingSingleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "multipleValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "values"
                        }
                      ],
                      "type": "JiraFormattingMultipleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "noValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        }
                      ],
                      "type": "JiraFormattingNoValueOperand"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "53cee9935758d1283f056e0039c8153a";

export default node;
